import React, { useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import CancelIcon from '@mui/icons-material/Cancel';

const LimitReachedHeader = (props) => {
	const { userBalance } = props;
	const [isHidden, setIsHidden] = useState(false);

	const handleClose = () => {
		setIsHidden(true);
	};
	return (
		<Box
			id='gclimit-popup'
			sx={{
				background: 'rgba(0,0,0,0.8)',
				position: 'fixed',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				textAlign: 'center',
				zIndex: 999,
				display: isHidden ? 'none' : 'block'
			}}
		>
			<Box
				sx={{
					position: 'fixed',
					top: '50%',
					left: '50%',
					width: '100%',
					maxWidth: '670px',
					transform: 'translate(-50%, -50%)',
					px: { xs: 5, md: 3 }
				}}
				py={3}
			>
				<Box
					sx={{
						background: '#fff',
						textAlign: 'center',
						color: 'primary',
						padding: { xs: '25px', md: '55px 25px' },
						position: 'relative'
					}}
				>
					<Typography
						variant='h6'
						sx={{
							fontSize: { xs: '1rem', md: '1.2rem', lg: '1.3rem' }
						}}
					>
						<ProductionQuantityLimitsIcon
							sx={{
								verticalAlign: 'middle',
								fontSize: {
									xs: 35,
									md: 39,
									lg: 59
								},
								color: 'primary',
								display: 'block',
								margin: '0 auto 10px'
							}}
						/>
						{`It looks like you have reached your limit this month! You'll be able to purchase more Gift Cards on ${
							userBalance.nextAvailablePurchaseDate ||
							dayjs(userBalance?.orderPlaced).add(30, 'day').format('MM/DD/YYYY')
						}.`}
					</Typography>
					<CancelIcon
						onClick={handleClose}
						aria-label='Close popup'
						sx={{
							verticalAlign: 'middle',
							fontSize: {
								xs: 35,
								md: 39
							},
							position: 'absolute',
							top: '-18px',
							right: {
								xs: '-33px',
								md: '-46px'
							},
							color: 'common.white',
							cursor: 'pointer',
							'&:hover': {
								opacity: 0.8
							}
						}}
					/>
				</Box>
			</Box>
		</Box>
	);
};

LimitReachedHeader.propTypes = {
	userBalance: PropTypes.object
};

export default LimitReachedHeader;
